import { create } from 'zustand'

const usei18next = create((set) => ({
	language: 'ko',
	setLanguage: (value) => set({ language: value }),
}))

export default usei18next
